import React from "react";
import { useSelector } from "react-redux";
import URLImages from "./URLImages";
import CustomizeImage from "./customizeImage";

export default function RoofDetail({ setSelectedImage, selectedImage, drag }) {
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;

  return roofData.map((item, index) => (
    <React.Fragment key={index}>
      {item.images &&
        item.images.length > 0 &&
        item.images.map((image, imageIndex) =>
          !item.customizeStructure && !item.newStructure ? (
            <URLImages
              image={image}
              key={imageIndex}
              setSelectedImageIndex={imageIndex}
              isSelected={
                selectedImage.length >= 0
                  ? selectedImage.some((selected) => selected.id === image.id)
                  : selectedImage === image
              }
              onSelect={setSelectedImage}
              selectedImage={selectedImage}
              images={item.images}
              drag={drag}
              check={index === roofIndex ? true : false}
            />
          ) : (
            <CustomizeImage
              image={image}
              key={imageIndex}
              setSelectedImageIndex={imageIndex}
              isSelected={
                selectedImage.length >= 0
                  ? selectedImage.some((selected) => selected.id === image.id)
                  : selectedImage === image
              }
              onSelect={setSelectedImage}
              selectedImage={selectedImage}
              images={item.images}
              drag={drag}
              check={index === roofIndex ? true : false}
            ></CustomizeImage>
          )
        )}
    </React.Fragment>
  ));
}
